import Immutable from "immutable";
const LOAD = 'earningsSending/LOAD';
const LOAD_SUCCESS = 'earningsSending/LOAD_SUCCESS';
const LOAD_FAIL = 'earningsSending/LOAD_FAIL';

const ALT_LOAD = 'earningsSending/ALT_LOAD';
const ALT_LOAD_SUCCESS = 'earningsSending/ALT_LOAD_SUCCESS';
const ALT_LOAD_FAIL = 'earningsSending/ALT_LOAD_FAIL';

const initialState = Immutable.fromJS({
    isLoad: false,
    loadErr: null,
    loading: false,
    earningsSetUp:{},
    altEarningsSetUp:{},
});
export default function reducer(state = initialState, action) {
    switch (action.type) {
        case LOAD:
            return state
                .set('isLoad', true)
                .set('loadErr', null);

        case LOAD_SUCCESS:
            return state
                .set('isLoad', false)
                .set('loadErr', null)
                .set('earningsSetUp', action.res);

        case LOAD_FAIL:
            return state
                .set('isLoad', false)
                .set('loadErr', action.error)
                .set('schedule', null);

        case ALT_LOAD:
            return state
                .set('isLoad', true)
                .set('loadErr', null);

        case ALT_LOAD_SUCCESS:
            return state
                .set('isLoad', false)
                .set('loadErr', null)
                .set('altEarningsSetUp', action.res);

        case ALT_LOAD_FAIL:
            return state
                .set('isLoad', false)
                .set('loadErr', action.error)
                .set('altEarningsSetUp', null);

        default:
            return state;
    }
}

export const getEarningsSendingSetup = () => async (dispatch, getState, api) => {
    dispatch({ type: LOAD });
    try {
        const resp =  await api.get("drPay/getEarningsSetUp");
        dispatch({ type: LOAD_SUCCESS, res:resp });
        return resp;
    } catch (err) {
        dispatch({ type: LOAD_FAIL,  error: err.message });
    }
};
